import { render, staticRenderFns } from "./PracticeEdit.vue?vue&type=template&id=f2ed640a&"
import script from "./PracticeEdit.vue?vue&type=script&lang=ts&"
export * from "./PracticeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports